import React from 'react';
import { useTranslation } from '@lt/localization';
import styled from 'styled-components';
import PackageInfoItem from '../components/PackageInfoItem';
import AboutRoomButton from '../../AboutRoom';
import GoToHotelContainer from '../../GoToHotel/GoToHotelContainer';
import type { PropsFromRedux } from '.';

const PackageRoomInfo = ({
  image,
  roomDescription,
  roomType,
  isMobile,
}: PropsFromRedux) => {
  const { t } = useTranslation();
  const icon = (
    <StyledAvatar>
      {image && <img src={image} alt={roomType || roomDescription} />}
    </StyledAvatar>
  );
  return (
    <PackageInfoItem icon={icon} isMobile={isMobile}>
      <div className="flex flex-space-between">
        <StyledRoomTypeContainer>
          <StyledRoomType isMobile={isMobile}>{roomDescription}</StyledRoomType>
          {roomType && <StyledOriginalRoom>{roomType}</StyledOriginalRoom>}

          <StyledAboutRoom isMobile={isMobile}>
            <AboutRoomButton />
          </StyledAboutRoom>
        </StyledRoomTypeContainer>
        <StyledGoToHotelContainer isMobile={isMobile}>
          {t('checkout.packageInfo.room.otherVariants')}
        </StyledGoToHotelContainer>
      </div>
    </PackageInfoItem>
  );
};

const StyledAvatar = styled.div`
  overflow: hidden;
  width: 30px;
  min-width: 30px;
  height: 30px;
  min-height: 30px;
  background: #919499;
  border-radius: 50%;

  img {
    max-width: 100%;
  }
`;

const StyledRoomTypeContainer = styled.div`
  display: flex;
  width: 100%;
  min-height: 30px;
  flex-direction: column;
  justify-content: center;
`;

const StyledRoomType = styled.h3<{ isMobile: boolean }>`
  display: flex;
  align-items: center;
  font-size: ${({ isMobile }) => (isMobile ? 13 : 14)}px;
  line-height: 16px;
  font-weight: normal;
  color: #4d4d4d;
`;

const StyledOriginalRoom = styled.span`
  margin-top: 2px;
  font-size: 12px;
  color: #919499;
`;

const StyledAboutRoom = styled.div<{ isMobile: boolean }>`
  font-size: 12px;
  ${({ isMobile }) => isMobile && `margin-bottom: -5px;`}
`;

const StyledGoToHotelContainer = styled(GoToHotelContainer)<{
  isMobile: boolean;
}>`
  position: relative;
  margin-left: auto; // align to the right
  padding: 0 13px 0 10px;
  height: 1.5rem;
  white-space: nowrap;
  text-decoration: none;
  color: #4d4d4d;
  ${({ isMobile }) =>
    isMobile &&
    `
    margin-top: -5px;
    padding: 0 13px 0 0;
    flex-direction: column-reverse;
    text-align: right;
  `}

  &::before,
  &::after {
    position: absolute;
    top: 10px;
    top: 8px;
    right: 0;
    margin-top: -14px;
    display: block;
    width: 0;
    height: 15px;
    content: '';
    border-right: 1px solid #4d4d4d;
    transform: rotate(155deg);
  }

  &::after {
    margin-top: -1px;
    transform: rotate(25deg);
  }
`;

export default PackageRoomInfo;
